export default __webpack_public_path__ + "static/media/portfolio-86.5d53c517.jpg";